import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Spinner } from "react-bootstrap";
import { FaUndoAlt } from "react-icons/fa";
import { AssetReturnActionApi } from "../../../services/AssetService";
import { toast } from "react-toastify";

const AssetReturnRequestActionModal = ({
  actionType,
  open,
  onClose,
  afterSubmit,
  assetData = {},
}) => {
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const isAccept = actionType === "accept";
  useEffect(() => {
    if (open) {
      setRemark("");
    }
  }, [open]);
  const handleApprove = () => {
    setLoading(true);
    AssetReturnActionApi(id, { remarks: remark, action: "ACCEPTED" })
      .then((res) => {
        toast.success("Return Accepted");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReject = () => {
    setLoading(true);
    AssetReturnActionApi(id, { remarks: remark, action: "REJECTED" })
      .then((res) => {
        toast.success("Return Rejected");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const { id, name, brand } = assetData?.asset || {};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        className={`d-flex align-items-center gap-2 ${
          isAccept ? "text-success" : "text-danger"
        }`}
      >
        <FaUndoAlt className="fs-4" />
        <span>
          {isAccept ? "Approve Return Request" : "Reject Return Request"}
        </span>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" className="mb-2">
          {isAccept
            ? "Are you sure you want to approve this return request?"
            : "Are you sure you want to reject this return request?"}
        </Typography>

        <div className="border rounded p-3 bg-light mb-2">
          <Typography variant="body2" className="mb-1">
            <strong>Asset Name:</strong> {name || "-"}
          </Typography>
          <Typography variant="body2">
            <strong>Brand:</strong> {brand || "-"}
          </Typography>
        </div>
        <TextField
          autoFocus
          label="Remarks"
          fullWidth
          value={remark}
          multiline
          rows={2}
          onChange={(e) => {
            const value = e.target.value;
            setRemark(value || "");
          }}
          placeholder="Enter remarks"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={isAccept ? handleApprove : handleReject}
          variant="contained"
          color={isAccept ? "success" : "error"}
          disabled={loading}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          {isAccept ? "Approve" : "Reject"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetReturnRequestActionModal;
